import React from 'react';
import GB from 'assets/img/flags/GB.png';
import RU from 'assets/img/flags/RU.png';
import UA from 'assets/img/flags/UA.png';
import DE from 'assets/img/flags/DE.png';
import CN from 'assets/img/flags/CN.png';
import FR from 'assets/img/flags/FR.png';
import IT from 'assets/img/flags/IT.png';
import PL from 'assets/img/flags/PL.png';
import ES from 'assets/img/flags/ES.png';
import SK from 'assets/img/flags/SK.png';
import DA from 'assets/img/flags/DA.png';
import BG from 'assets/img/flags/BG.png';
import RO from 'assets/img/flags/RO.png';
import HR from 'assets/img/flags/HR.png';
import CS from 'assets/img/flags/CS.png';
import NL from 'assets/img/flags/NL.png';
import ET from 'assets/img/flags/ET.png';
import FI from 'assets/img/flags/FI.png';
import EL from 'assets/img/flags/EL.png';
import HU from 'assets/img/flags/HU.png';
import GA from 'assets/img/flags/GA.png';
import LV from 'assets/img/flags/LV.png';
import LT from 'assets/img/flags/LT.png';
import MT from 'assets/img/flags/MT.png';
import PT from 'assets/img/flags/PT.png';
import SL from 'assets/img/flags/SL.png';
import SV from 'assets/img/flags/SV.png';
import { TCountryCode } from 'types';
import style from './CountryFlag.module.scss';

interface ICountryFlag {
	countryCode: TCountryCode;
	size: string;
}

const CountryFlag: React.FC<ICountryFlag> = ({ countryCode, size }) => {
	const flags = {
		GB,
		RU,
		UA,
		DE,
		CN,
		FR,
		IT,
		PL,
		ES,
		SK,
		DA,
		BG,
		RO,
		HR,
		CS,
		NL,
		ET,
		FI,
		EL,
		HU,
		GA,
		LV,
		LT,
		MT,
		PT,
		SL,
		SV,
	};

	return (
		<div className={style.image}>
			<img src={flags[countryCode]} alt="flag" width={size} height={size} />
		</div>
	);
};

export default React.memo(CountryFlag);
